module.exports = require('./helpers/bundle-url').getBundleURL('1XeXB') + "logo-dark.eefe0b7f.svg";